<div class="tray__container">
  <header class="tray__header">
    <a class="tray-header__button" [class.active]="viewMode === 'list'"
       [ngbTooltip]="'Previous chats'" (click)="onShowList()">
      <i class="ico-list"></i>
    </a>
    <a class="tray-header__button" [ngbTooltip]="'New chat'" (click)="onNewConversation()">
      <i class="ico-chat-message-plus"></i>
    </a>
    <a class="tray-header__button" (click)="onClose()">
      <i class="ico-close"></i>
    </a>
  </header>

  <div class="tray__list" #messageList>

    <div class="tray-list" *ngIf="viewMode === 'list'" (scroll)="onScrollConversations($event)">
      <div class="tray-list__message" *ngFor="let conv of conversations"
           (click)="onSelectConversation(conv)">
        <div class="message__status">
          <span class="ai__icon"></span>
        </div>
        <div class="message__details">
          <div class="message__title">{{ conv.title }}</div>
          <span class="message__timestamp">{{ conv.updatedAt }}</span>
        </div>
        <a class="icon-action scan-doc-button" [ngbTooltip]="'Delete chat'"
           (click)="onDeleteConversation(conv, $event)">
          <i class="ico-trash"></i>
        </a>
      </div>
    </div>

    <div class="message-list" *ngIf="viewMode === 'conversation'">
      <div class="message" *ngFor="let msg of messages; let i = index">
        <div class="message-container"
             [class.message-container--manager]="msg.role === 'user'"
             [class.message-container--ai]="msg.role === 'assistant'">
          <div class="message-body init-message">
            <div class="message-text">
              <pre>{{ msg.content }}</pre>
            </div>
          </div>
          <div class="msg__user-type">
            <i *ngIf="msg.role === 'user'" class="ico-user chat-user-img"></i>
            <i *ngIf="msg.role === 'assistant'" class="ico-ai chat-user-img"></i>
          </div>
        </div>
        <div class="message__feedback" *ngIf="msg.role === 'assistant'">
          <a [ngbTooltip]="'Copy'" (click)="onCopy(msg.content)"><i class="ico-copy"></i></a>
          <a [ngbTooltip]="'Helpful answer'" (click)="onFeedback(i, 'liked')"><i class="ico-like"></i></a>
          <a [ngbTooltip]="'Bad answer'" (click)="onFeedback(i, 'disliked')"><i class="ico-like-not"></i></a>
          <a [ngbTooltip]="'Retry'" (click)="onRetry()"><i class="ico-refresh"></i></a>
        </div>
      </div>

      <div class="message" *ngIf="streamingText">
        <div class="message-container message-container--ai">
          <div class="message-body init-message">
            <div class="message-text">
              <pre>{{ streamingText }}</pre>
            </div>
          </div>
          <div class="msg__user-type">
            <i class="ico-ai chat-user-img"></i>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="tray__input form--soft" *ngIf="viewMode === 'conversation'">
    <div class="input-group chat-text">
      <textarea class="form-control"
                rows="1"
                placeholder="Ask anything"
                maxlength="10000"
                [(ngModel)]="inputText"
                (keydown)="onKeyDown($event)"></textarea>
      <div class="input__buttons">
        <a class="input__button" *ngIf="!isStreaming" [ngbTooltip]="'Send'" (click)="onSend()">
          <i class="ico-send"></i>
        </a>
        <a class="input__button" *ngIf="isStreaming" [ngbTooltip]="'Stop'" (click)="onStop()">
          <i class="ico-stop"></i>
        </a>
      </div>
    </div>
  </div>
</div>
